import { PlatformChip } from "@/components/PlatformBadge";
import { fmtCompact } from "@/lib/format";
import { Heart, MessageCircle, Share2 } from "lucide-react";

export default function ContentCard({ post, className = "" }) {
  const date = new Date(post.publish_date).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  return (
    <div data-testid={`content-card-${post.post_id}`} className={`group overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm transition-all hover:-translate-y-1 hover:shadow-md ${className}`}>
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={post.thumbnail_url} alt={post.caption} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute inset-x-0 top-0 flex items-center justify-between p-3">
          <PlatformChip platform={post.platform} />
          <span className="rounded-full bg-black/50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white backdrop-blur">{post.media_type}</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 to-transparent p-3 pt-8">
          <div className="flex items-end justify-between gap-2 text-white">
            <div>
              <p className="text-lg font-bold leading-none">{fmtCompact(post.reach)}</p>
              <p className="text-[11px] text-white/80">Reach</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-bold leading-none">{fmtCompact(post.engagement)}</p>
              <p className="text-[11px] text-white/80">Engagement</p>
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-3 p-4">
        <p className="line-clamp-2 min-h-[2.5rem] text-sm text-foreground">{post.caption}</p>
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{date}</span>
          <span className="font-semibold text-brand-primary">{post.engagement_rate}% ER</span>
        </div>
        <div className="flex items-center gap-4 border-t border-border/60 pt-3 text-xs text-muted-foreground">
          <span className="inline-flex items-center gap-1"><Heart className="h-3.5 w-3.5" />{fmtCompact(post.likes)}</span>
          <span className="inline-flex items-center gap-1"><MessageCircle className="h-3.5 w-3.5" />{fmtCompact(post.comments)}</span>
          <span className="inline-flex items-center gap-1"><Share2 className="h-3.5 w-3.5" />{fmtCompact(post.shares)}</span>
        </div>
      </div>
    </div>
  );
}
